import { Routes } from '@angular/router';
import { CpRedirectComponent } from './pages/cp-redirect/cp-redirect.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'selectmasjid',
        pathMatch: 'full'
    },
    {
        path: 'selectmasjid',
        loadComponent: () => import('./pages/selectmasjid/selectmasjid.component').then(c => c.SelectmasjidComponent),
        title: 'Select Masjid'
    },
    {
        path: 'timingscreen/:id',
        loadComponent: () => import('./pages/screens/timingscreen/timingscreen.component').then(c => c.TimingscreenComponent),
        data: { preload: true },
        title: 'Timing Screen'
    },
    {
        path: 'timinginfoscreen/:id',
        loadComponent: () => import('./pages/screens/time-info-screen/time-info-screen.component').then(c => c.TimeInfoScreenComponent),
        title: 'Time Info Screen'
    },
    {
        path: 'infoscreen/:id',
        loadComponent: () => import('./pages/screens/info-screen/info-screen.component').then(c => c.InfoScreenComponent),
        title: 'Info Screen'
    },
    {
        path: 'salahscreen/:id',
        loadComponent: () => import('./pages/screens/multiple-salah-screen/multiple-salah-screen.component').then(c => c.MultipleSalahScreenComponent),
        title: 'Multiple Salah Screen'
    },
    {
        path: 'mobilescreen/:id',
        loadComponent: () => import('./pages/screens/mobile-screen/mobile-screen.component').then(c => c.MobileScreenComponent),
        title: 'Mobile Screen'
    },
    {
        path: 'mobilescreen',
        loadComponent: () =>
            import('./pages/missing-guide/missing-guide.component').then(c => c.MissingGuideComponent),
        title: 'Missing Guide'
    },
    {
        path: 'sharescreen/:id',
        loadComponent: () => import('./pages/screens/share-screen/share-screen.component').then(c => c.ShareScreenComponent),
        title: 'Share Screen'
    },
    {
        path: 'widget/:id',
        loadComponent: () => import('./pages/widget/medium-size-widget/widget.component').then(c => c.WidgetComponent),
        title: 'Widget'
    },
    {
        path: 'ramadanscreen/:id',
        loadComponent: () => import('./pages/screens/ramadam-screen/ramadam-screen.component').then(c => c.RamadamScreenComponent),
        title: 'Ramadan Screen'
    },
    {
        path:"portrait_timingscreen/:id",
        loadComponent: () => import('./pages/screens/potrait-timing-screen/potrait-timing-screen.component').then(c => c.PotraitTimingScreenComponent),
        title: 'portrait Timing Screen'
    },
    {
        path: 'login',
        component:CpRedirectComponent,
        title:'Redirecting to CP' // Ensure the full path is matched
    },
    { path: '**', redirectTo: 'selectmasjid', pathMatch: 'full' }
];
